import { Api } from "../../core/services/api.services";
import { FormDynamic } from "../../shared/interface/form-dynamic";
import LayoutMain from "../../shared/layouts/LayoutMain/LayoutMain";
import { BCButton, BCFormList, BCFormListCont, BCFormListHeader } from "../../shared/styled/global.styled";
import { useService } from "../../hook/useServices";
import { useNavigate } from "react-router-dom";
import BcIcon from "../../shared/components/Bc-Icon/Bc-icon";


const getForms = async () => {
  const { data } = await Api.getForms();
  return data;
};

const FormsPage = () => {
  const navigate = useNavigate();
  const serviceQuery = useService('forms', getForms);
  const forms: FormDynamic[] = serviceQuery.data as unknown as FormDynamic[];
  
  return (
    <LayoutMain idPage="Formularios" titlePage={true}>

      <BCFormListHeader className="bc-mb-4">
        <h2>Es momento de crear tu primer formulario dinamico</h2>
        <BCButton
                type="button"
                className="bc-button-primary bc-button-small"
                onClick={() => navigate(`/formularios/crear`)}
              >
                Crear formulario
              </BCButton>
      </BCFormListHeader>

      { serviceQuery.isLoading && <div className="bc-preloader bc-preloader-line"></div>}
      {forms &&
        forms.map((form: FormDynamic) => (
          <BCFormList className="bc-card" key={form.id}>
            <BCFormListCont>
            <span><h6>Id: </h6>
            <p>{form.id}</p></span>
            <span><h6>Nombre: </h6>
            <p>{form.name}</p></span>
            <span><h6>Cantidad de campos: </h6>
            <p>{form.fields.length}</p></span>
            </BCFormListCont>
            <div className="bc-flex bc-justify-content-flex-end">
              <BCButton
                type="button"
                className="bc-button-secondary bc-button-small"
                onClick={() => navigate(`/formularios/ver/${form.id}`)}
              >
                Ver
              </BCButton>
              <BCButton
                type="button"
                className="bc-button-primary bc-button-small"
                disabled={true}
                onClick={() => navigate(`/formularios/${form.id}`)}
              >
                Editar
              </BCButton>
              <BCButton
                type="button"
                className="bc-button-primary bc-button-small"
                disabled={true}
                onClick={() => navigate(`/formularios/${form.id}`)}
              >
                <BcIcon iconName="erase" />
              </BCButton>
            </div>
          </BCFormList>
        ))}
    </LayoutMain>
  );
};

export default FormsPage;
